import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

const environment = import.meta.env.MODE || 'development';
const sentryDsn = 'https://39a3787a9d76187b9fbd1b43159eee96@o4509275653996544.ingest.us.sentry.io/4511378211667968';

console.log('Current environment mode:', environment);

// Initialize Sentry for production and staging environments
if (environment === 'production' || environment === 'staging') {
  Sentry.init({
    dsn: sentryDsn,
    environment: environment,
    sendDefaultPii: true,
    tracesSampleRate: 1.0,
    
    // Enable source maps for better error tracking
    attachStacktrace: true,
    
    // Source map configuration
    sourceMaps: {
      enabled: true,
      includeCommitSha: false,
    },
    
    integrations: [
      new BrowserTracing({
        tracingOrigins: [
          'localhost',
          /^\//, 
          import.meta.env.VITE_APP_API_URL,
        ],
      }),
    ],
  });

  console.log('Sentry initialized for environment:', environment);
} else {
  console.log('Sentry disabled for environment:', environment);
}

export default Sentry;
